import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.connectorDefinition.DOC}
  query IntegrationConnectorDefinition($tenantId: ID!, $zoneId: ID!, $id: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        intgConnectorDefinition(id: $id) {
          ...FragmentIntegrationConnectorDefinition
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.IntegrationConnectorDefinitionQuery,
    ents.core.integrations.Connector.Definition,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'intgConnectorDefinition',
        fragments.connectorDefinition.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.IntegrationConnectorDefinitionQuery,
  ents.core.integrations.Connector.Definition,
  graphql.schema.IntegrationConnectorDefinitionQueryVariables
>({ query: DOC, transformer: TRANSFORMER })
